import { EvidenceStatus, SyncStatus } from '@seapoint/server/enums';
import { Stack } from '../../../../../design-system/stack/stack';
import { InvoiceEvidenceView } from '../../../../../types/entity-types';
import { EvidenceCard } from './evidence-card';

type EvidenceWrapperProps = {
  evidence: InvoiceEvidenceView[];
  onViewEvidence: (documentId: string) => void;
  onDownloadEvidence: (documentId: string) => void;
};

export const EvidenceWrapper = ({ evidence, onViewEvidence, onDownloadEvidence }: EvidenceWrapperProps) => {
  return (
    <Stack space={4} className="w-full">
      <p className="text-base leading-[22px] font-medium tracking-[-0.02em]">Evidence</p>
      <Stack space={3} className="w-full">
        {evidence.map((item) => {
          // Find Xero external reference (if exists)
          const xeroRef = item.externalReferences?.find((ref) => ref.externalEntityType === 'INVOICE');

          // Build xeroSyncConfig based on sync status
          const xeroSyncConfig = xeroRef?.syncStatus
            ? xeroRef.syncStatus === SyncStatus.FAILED
              ? {
                  status: SyncStatus.FAILED as const,
                  error:
                    xeroRef.metadata && typeof xeroRef.metadata === 'object' && 'lastError' in xeroRef.metadata
                      ? ((xeroRef.metadata.lastError as { message?: string })?.message ?? null)
                      : null,
                }
              : { status: xeroRef.syncStatus }
            : null;

          return (
            <EvidenceCard
              key={item.id}
              fileName={item.document?.fileName ?? 'File Name'}
              documentId={item.document?.id ?? ''}
              evidenceStatus={item.status === EvidenceStatus.COMPLETED ? EvidenceStatus.COMPLETED : undefined}
              xeroSyncConfig={xeroSyncConfig}
              onViewEvidence={onViewEvidence}
              onDownloadEvidence={onDownloadEvidence}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};
